<script lang="ts">
    import currentTheme from "$lib/state/theme";
    import { updateSetting } from "$lib/state/settings";
    import { browser } from "$app/environment";

    const toggleTheme = () => {
        const next = $currentTheme === "dark" ? "light" : "dark";
        updateSetting({ appearance: { theme: next } });
        if (browser) {
            document.body.id = `body-${next}`;
        }
    };
</script>

<button
    class="theme-switch"
    onclick={toggleTheme}
    role="switch"
    aria-checked={$currentTheme === "dark"}
    title="Cambiar tema visual"
    aria-label="Cambiar tema visual"
>
    <span class="switch-option" class:active={$currentTheme === "light"} title="Modo Claro">
        <svg class="theme-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="4"></circle>
            <path d="M12 2v2"></path>
            <path d="M12 20v2"></path>
            <path d="m4.93 4.93 1.41 1.41"></path>
            <path d="m17.66 17.66 1.41 1.41"></path>
            <path d="M2 12h2"></path>
            <path d="M20 12h2"></path>
            <path d="m6.34 17.66-1.41 1.41"></path>
            <path d="m19.07 4.93-1.41 1.41"></path>
        </svg>
    </span>
    <span class="switch-option" class:active={$currentTheme === "dark"} title="Modo Oscuro">
        <svg class="theme-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
        </svg>
    </span>
</button>

<style>
    .theme-switch {
        display: inline-flex;
        align-items: center;
        background: var(--button);
        border: 1px solid var(--button-stroke);
        border-radius: 999px;
        padding: 3px;
        cursor: pointer;
        gap: 3px;
        transition: all 0.2s ease;
    }

    .theme-switch:hover {
        border-color: #F1BE48;
    }

    .switch-option {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        color: var(--gray);
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .switch-option.active {
        background: #F1BE48;
        color: #10100F;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    }

    .theme-svg {
        width: 14px;
        height: 14px;
    }
</style>
